import { ValueSetterParams } from "ag-grid/dist/lib/entities/colDef";

export class AgValueSetter {

  static valueSetter(params: ValueSetterParams, itemList: any[], field?: string) {
    if (params.oldValue == params.newValue) return false;
    if (!itemList || itemList.length <= 0) return false;

    let value: string = params.newValue;
    if (!value) {
      params.data[params.colDef.field] = null;
      return true;
    }

    let codeFormats: RegExpMatchArray = value.match(/^\[\S*\]/);
    let code: string = value.trim();
    if (codeFormats && codeFormats.length > 0) code = codeFormats[0].substring(1, codeFormats[0].length - 1);    
    code = code.toUpperCase();
    
    let findDatas: any[] = itemList.filter(data => {
      let compareData: any = field ? data[field]: data;
      return compareData == code;
    });

    let result: any = findDatas ? findDatas[0] : null
    params.data[params.colDef.field] = result;
    
    return true;
  }


}


// WEBPACK FOOTER //
// ./src/app/components/ag-grid/ag-value-setter.ts